import { useValidatePackageRequiredHotelShopQueryParams } from "./useValidatePackageRequiredHotelShopQueryParams";

export const usePackageHotelShopPageRoute = () => {
  return useValidatePackageRequiredHotelShopQueryParams();
};
